@if (request(); as currentRequest) {
    @for (shownSuggestion of suggestion() ? [suggestion()!] : []; track shownSuggestion) {
        <app-suggestion-details
            [suggestion]="shownSuggestion"
            [userType]="userType()"
            [newSuggestion]="!currentRequest.suggestionId"
            [startStep]="currentRequest.suggestionId ? undefined : currentRequest.startStep"
            [editSuggestion]="false"
            [shouldOpenConversation]="shouldOpenConversation()"
            (closeDetails)="close()"
            (suggestionEdited)="saved.emit($event)" />
    }
}
